"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var lodash_1 = require("lodash");
var constants_1 = require("../constants");
var utils_1 = require("../utils");
var usePollingMinStake_1 = __importDefault(require("./usePollingMinStake"));
var DEFAULT_BET_VARIANTS = [3, 5, 10, 20, 50, 100];
function useSuggests(_a) {
    var maxStake = _a.maxStake, count = _a.count, skip = _a.skip, algorithm = _a.algorithm;
    var minStake = usePollingMinStake_1.default().minStake;
    var _b = react_1.useState(null), suggests = _b[0], setSuggests = _b[1];
    var maxBet = maxStake ? +maxStake : constants_1.DEFAULT_MAX_STAKE;
    react_1.useEffect(function () {
        if (skip) {
            return;
        }
        if (maxBet === constants_1.DEFAULT_MAX_STAKE) {
            setSuggests(null);
            return;
        }
        if (!minStake)
            return;
        utils_1.getSuggests({
            maxStake: "" + maxBet,
            minStake: "" + minStake,
            count: count,
            algorithm: algorithm,
        })
            .then(function (s) { return setSuggests(s.map(function (i) { return lodash_1.toNumber(i); })); })
            .catch(function (err) {
            console.error(err);
        });
    }, [maxBet, skip, minStake, algorithm, count]);
    var getSortedBetVariants = react_1.useCallback(function () {
        return __spreadArray(__spreadArray([], lodash_1.sortBy(DEFAULT_BET_VARIANTS.filter(function (i) { return i < +maxBet; })).slice(0, count - 1)), [
            +maxBet,
        ]);
    }, [maxBet, count]);
    var betVariants = suggests || getSortedBetVariants();
    return {
        suggests: betVariants,
        isDefaultSuggests: !suggests,
    };
}
exports.default = useSuggests;
//# sourceMappingURL=useSuggests.js.map